import App from "./app/App.react";
import Dashboard from "./dashboard/Page.react";
import Login from "./auth/Login.react";
import Logout from "./auth/Logout.react";
import Forgot from "./auth/Forgot.react";
import SetPassword from "./auth/SetPassword.react";
import NotFound from "./auth/Notfound.react";
import isLogged from "./isLogged/Page.react.js";
import Profile from "./profile/Page.react.js";
import Users from "./users/Page.react.js";
import React from "react";
import PageEdit from "./pageEdit/pageEdit.react";
import Pages from "./pages/pages.react";
import MediaCategories from "./mediaCategories/mediaCategories.react";
import MediaCategory from "./mediaCategory/mediaCategory.react";
import Templates from "./templates/templates.react";
import Template from "./template/template.react";
import Menus from "./menus/menus.react";
import Menu from "./menu/menu.react";
import PagesLists from "./pagesLists/pagesLists.react";
import PagesList from "./pagesList/pagesList.react";
import PagesListCategories
  from "./pagesListCategories/pagesListCategories.react";
import Post from "./post/post.react";
import Orders from "./orders/orders.react";
import Order from "./order/order.react";
import FieldCategories from "./fieldCategories/fieldCategories.react";
import FieldCategory from "./fieldCategory/fieldCategory.react";
import FormSubmissions from "./formSubmissions/formSubmissions.react";
import FormSubmission from "./formSubmission/formSubmission.react";
import { IndexRoute, Route, Redirect } from "react-router";

export default function createRoutes(getState) {
  function requireAuth(nextState, replaceState) {
    if (getState().users !== undefined) {
      const loggedIn = getState().users.viewer &&
        getState().users.viewer.accessToken;
      if (!loggedIn) {
        replaceState(
          {
            nextPathname: nextState.location.pathname
          },
          "/login"
        );
      }
    } else {
      replaceState(
        {
          nextPathname: nextState.location.pathname
        },
        "/login"
      );
    }
  }

  function requireDeveloper(nextState, replaceState) {
    let isDeveloper = false;
    getState().users
      .getIn(["currentUser", "groups"])
      .forEach(function(group, index) {
        if (group.name === "developer") {
          isDeveloper = true;
        }
      });
    if (!isDeveloper) {
      replaceState(
        {
          nextPathname: nextState.location.pathname
        },
        "/"
      );
    }
  }

  function requireAdmin(nextState, replaceState) {
    let isAdmin = false;
    getState().users
      .getIn(["currentUser", "groups"])
      .forEach(function(group, index) {
        if (group.name === "admin") {
          isAdmin = true;
        }
      });
    if (!isAdmin) {
      replaceState(
        {
          nextPathname: nextState.location.pathname
        },
        "/"
      );
    }
  }

  return (
    <Route component={App} path="/">
      <Route component={isLogged} onEnter={requireAuth}>
        <IndexRoute component={Dashboard} />
        <Route component={Profile} path="profile" />
        <Route component={Pages} path="pages" />
        <Route component={Users} path="users" onEnter={requireAdmin} />
        <Route component={PageEdit} path="pages/:slug" />
        <Route component={MediaCategories} path="mediaCategories" />
        <Route component={MediaCategory} path="mediaCategories/:uid" />
        <Route
          component={Templates}
          path="templates"
          onEnter={requireDeveloper}
        />
        <Route
          component={Template}
          path="templates/:uid"
          onEnter={requireDeveloper}
        />
        <Route component={Menus} path="menus" />
        <Route component={Menu} path="menus/:placeholder" />
        <Route component={PagesLists} path="pagesLists" />
        <Route component={PagesList} path="pagesLists/:slug" />
        <Route
          component={PagesListCategories}
          path="pagesLists/:slug/categories"
        />
        <Route component={Post} path="pagesLists/:slug/:uid" />
        <Route component={Orders} path="orders" />
        <Route component={Order} path="orders/:uid" />
        <Route component={FieldCategories} path="fieldCategories" />
        <Route component={FieldCategory} path="fieldCategories/:placeholder" />
        <Route component={FormSubmissions} path="form-submissions" />
        <Route component={FormSubmission} path="form-submissions/:uid" />
      </Route>
      <Route component={Login} path="login" />
      <Route component={Logout} path="logout" />
      <Route component={Forgot} path="forgot" />
      <Route component={SetPassword} path="set-password/:token" />
      <Route component={NotFound} path="*" />
    </Route>
  );
}



// WEBPACK FOOTER //
// ./src/browser/createRoutes.js